import React from 'react';
import EmailCampaignTable from "../../components/Dashboard/EmailCampaignTable";
import Insights from "../../components/Dashboard/Insights";
import CampaignInsights from "../../components/Dashboard/InsightsSlider";
import OptimizationScore from "../../components/Dashboard/OptimizationScore";
import RecentlyCreated from "../../components/Dashboard/RecentDocument";
import Recommendations from "../../components/Dashboard/Recommandations";
import SkillCard from "../../components/Dashboard/SkillCard";
import RecommendationsUpdate from "../../components/Dashboard/Updates";

const Dashboard = () => {
  const scoreData = {
    userName: "Anupam",
    score: 85,
    campaigns: {
      confirmed: 1,
      unconfirmed: 3
    }
  };
  return (
    <>
    <div className="row">
      <div className="col-8">
       <OptimizationScore {...scoreData} />
       </div>
       <div className="col-4">
       <SkillCard />
       </div>
       </div>
       <div className="row mt-4">
        <div className="col-8">
       <Insights />
       </div>
       <div className="col-4"> 
      <RecommendationsUpdate />
       </div>
       </div>
       <div className="row mt-4">
      <div className="col-8">
       <Recommendations />
       </div>
       <div className="col-4">
       <RecentlyCreated />
       </div>
       </div>
       <div className="mt-5">
       <CampaignInsights />
       </div>
       <div className="mt-3">
       <EmailCampaignTable />
       </div>
    </>
  );
};

export default Dashboard;
